/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type SummaryText = {
  type: "summary_text";
  text: string;
};

/** @internal */
export const SummaryText$inboundSchema: z.ZodType<
  SummaryText,
  z.ZodTypeDef,
  unknown
> = z.object({
  type: z.literal("summary_text"),
  text: z.string(),
});
/** @internal */
export type SummaryText$Outbound = {
  type: "summary_text";
  text: string;
};

/** @internal */
export const SummaryText$outboundSchema: z.ZodType<
  SummaryText$Outbound,
  z.ZodTypeDef,
  SummaryText
> = z.object({
  type: z.literal("summary_text"),
  text: z.string(),
});

export function summaryTextToJSON(summaryText: SummaryText): string {
  return JSON.stringify(SummaryText$outboundSchema.parse(summaryText));
}
export function summaryTextFromJSON(
  jsonString: string,
): SafeParseResult<SummaryText, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => SummaryText$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'SummaryText' from JSON`,
  );
}
